var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9216(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9216",
    "data-name": "Group 9216",
    transform: "translate(-44 -95)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(44 95)",
    fill: "#00ca7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(50 102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3625",
    "data-name": "Grupo 3625",
    transform: "translate(9.185 4.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3624",
    "data-name": "Grupo 3624",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3714",
    "data-name": "Trazado 3714",
    d: "M200.934,140.512v-4.554a2.357,2.357,0,0,1,1.2,2.057,1.144,1.144,0,0,0,2.285,0,4.652,4.652,0,0,0-3.5-4.5V133.2a1.144,1.144,0,0,0-2.285,0v.315a4.645,4.645,0,0,0,0,9v4.556a2.357,2.357,0,0,1-1.2-2.057,1.144,1.144,0,0,0-2.285,0,4.653,4.653,0,0,0,3.5,4.5v.315a1.144,1.144,0,0,0,2.285,0v-.315a4.645,4.645,0,0,0,0-9Zm-2.285-.441a2.353,2.353,0,0,1,0-4.115Zm2.285,7v-4.115a2.353,2.353,0,0,1,0,4.115Z",
    transform: "translate(-195.14 -132.105)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9216);
export default __webpack_public_path__ + "static/media/Group 9216.d78331149e219b82304d4d52bff3c24f.svg";
export { ForwardRef as ReactComponent };